import { NewJobDesktop, NewJobInitialValues } from './NewJobDesktop';

interface NewJobModalProps {
  isOpen: boolean;
  onClose: () => void;
  onJobCreated: () => void;
  initialValues?: NewJobInitialValues;
}

export function NewJobModal(props: NewJobModalProps) {
  return <NewJobDesktop {...props} />;
}
